import { useLocation, useNavigate, useParams } from "react-router-dom";
import { baseURL, imageURL } from "../../../../Services/api/baseURL";
import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { ArrowLeftCircle } from "react-feather";

const ProductDetails = () => {
  const location = useLocation();
  const { id } = useParams(); // fallback if URL is loaded directly

  const navigate = useNavigate()

  const { product, storeId } = location.state || {};
  const [inventoryLog, setInventoryLog] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!product?._id || !storeId) return;
    setLoading(true);

    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const res = await axios.get(
          `${baseURL}/api/admin/get-stock-inventory/${storeId}/product/${product._id}`,
          { headers: { Authorization: `${token}` } }
        );

        setInventoryLog(res.data.data || []);
      } catch (err) {
        console.error("Error fetching stock data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [storeId, product?._id]);

  if (!product) {
    return <p className="text-red-500 p-4">No product info. (Maybe reload with state)</p>;
  }


  return (
    <div className="p-6">
       
      {/* Product Header */}
<div className="bg-white rounded-xl shadow p-6 mb-2 space-y-6">
  {/* Product Title */}

<button
        onClick={() => navigate(-1)}
        className=""
      >
         <ArrowLeftCircle className="text-gray-500"/>
      </button>

  <h1 className="text-2xl font-semibold text-gray-800">
    {product.productName}
  </h1>

  {/* Brand */}
  {/* {product.brand && (
    <p className="text-gray-600">
      <span className="font-medium">Brand:</span> {product.brand}
    </p>
  )} */}

  {/* Variants */}
  {product.variants?.length > 0 && (
    <div>
      <h2 className="text-lg font-semibold text-gray-700 mb-3">
        Available Variants
      </h2>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {product.variants.map((variant) => (
          <li
            key={variant._id}
            className="flex items-center gap-3 p-1 border rounded-lg hover:shadow-sm"
          >
            {variant.variantImage ? (
              <img
                src={`${imageURL+variant.variantImage}`}
                alt={variant.variantName}
                className="w-14 h-14 object-cover "
              />
            ) : (
              <div className="w-14 h-14 flex items-center justify-center bg-gray-100 rounded text-gray-400">
                No Img
              </div>
            )}

            <div>
              <p className="font-medium text-gray-800 ">{variant.variantName}</p>
              {variant.alcohol_percentage && (
                <p className="text-xs text-gray-500">
                  {variant.alcohol_percentage}% alc/vol
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )}
</div>


      {/* Inventory Log */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">
          Inventory Log
        </h2>

        {loading ? (
          <p className="text-gray-500">Loading...</p>
        ) : inventoryLog.length === 0 ? (
          <p className="text-gray-500">No inventory records found.</p>
        ) : (
<div className="overflow-x-auto">
  <table className="min-w-full border border-gray-200 text-sm">
    <thead className="bg-gray-100 text-left">
      <tr>
        <th className="p-2 border-b">Sl.No</th>
        <th className="p-2 border-b">Prev Qty</th>
        <th className="p-2 border-b">Qty Changed</th>
        <th className="p-2 border-b">Current Qty</th>
        <th className="p-2 border-b">Reason</th>
        <th className="p-2 border-b">Performed By</th>
        <th className="p-2 border-b">Date</th>
      </tr>
    </thead>

    <tbody>
      {inventoryLog.map((log,index) => {
        const isPositive = log.quantity_changed > 0;
        const currentQty = log.previous_quantity + log.quantity_changed;

        return (
          <tr key={log._id} className="hover:bg-gray-50">
            {/* Change indicator */}
                {/* Previous quantity */}
                <td className="p-2 border-b">{index+1}</td>
                <td className="p-2 border-b">{log.previous_quantity}</td>
            <td className="p-2 border-b">
              <span
                className={`font-bold text-lg ${
                  isPositive ? "text-green-600" : "text-red-600"
                }`}
              >
                {isPositive ? "+" : "-"}
                {Math.abs(log.quantity_changed)}
              </span>
            </td>


            {/* Current quantity */}
            <td className="p-2 border-b font-semibold text-gray-800">
              {currentQty}
            </td>

            <td className="p-2 border-b">{log.reason}</td>
            <td className="p-2 border-b">{log.performed_by}</td>
            <td className="p-2 border-b">
              {moment(log.createdAt).format("DD/MM/YYYY hh:mm A")}
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>


        )}
      </div>
    </div>
  );
};

export default ProductDetails;
